import React from 'react';
import SarasTooltip from '../../notifications/SarasTooltip';
import SarasTrans from '../../notifications/SarasTrans';
import * as fn from '../../../helper/uiFunctions';

const FormROValueWithTooltip = (props) => {
    const { formObject, translate, action, rowKey, headerKey, format, customWrapper, wrapperClass, className, ...restProps } = props;

    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName)
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");

    const getValue = () => {
        let value = formObject.getValueFromKey(viewData, "dataList.valS", viewData.valF || viewData.val);

        if (format === "#" && fn.compareNumber(value, 0))
            value = '';

        if (format === "hhmm")
            value = fn.convertMinutesToHHMM(value);

        if(translate){
            return (
                <SarasTrans value={value} />
            )
        }

        return value;
    }

    const getStyle = () => {
        if (viewData.dataList && viewData.dataList.colCssStyle && viewData.dataList.colCssStyle !== "") {
            return JSON.parse(viewData.dataList.colCssStyle)
        }
        else {
            return {}
        }
    }

    if (viewData && hide === "0") {
        return (
            <SarasTooltip title={viewData.dataList ? viewData.dataList.title : ''}>
                <span className={`${className} ${viewData.dataList ? viewData.dataList.colCssClass : ''}`} style={getStyle()} {...restProps}>{getValue()}</span>
            </SarasTooltip>
        )
    }

    return (null);
}

export default FormROValueWithTooltip